"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const use_debounce_1 = require("use-debounce");
const clsx_1 = __importDefault(require("clsx"));
const tree_context_1 = require("./tree-context");
const tree_input_1 = require("./tree-input");
const tree_popup_1 = require("./tree-popup");
const tree_styles_1 = require("./tree-styles");
const tree_chips_1 = require("./tree-chips");
const tree_disabled_component_1 = require("./tree-disabled-component");
function Tree({ form, disabled, value, onChange, source, DisabledComponent = tree_disabled_component_1.TreeDisabledComponent, }) {
    const props = { disabled, source, value, onChange, form };
    const sorted = (value !== null && value !== void 0 ? value : []).sort((a, b) => (a.label > b.label ? 1 : -1));
    const classes = tree_styles_1.useStyles();
    const anchorElRef = react_1.useRef(null);
    const inputRef = react_1.useRef(null);
    const [popupOpen, setPopupOpen] = react_1.useState(false);
    const [textValue, setTextValue] = react_1.useState('');
    const [setSearchQuery] = use_debounce_1.useDebouncedCallback((value) => {
        react_dom_1.unstable_batchedUpdates(() => {
            var _a;
            source.setSearchQuery(value !== null && value !== void 0 ? value : '');
            source.reset();
            source.loadMore();
            if (popupOpen) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        });
    }, 500);
    return (react_1.default.createElement(tree_context_1.TreeContext.Provider, { value: props },
        react_1.default.createElement("div", { className: clsx_1.default('EasInput-root', classes.wrapper, {
                [classes.wrapperDisabled]: disabled,
            }) }, disabled ? (react_1.default.createElement(DisabledComponent, { disabled: true, value: sorted !== null && sorted !== void 0 ? sorted : [] })) : (react_1.default.createElement("div", null,
            react_1.default.createElement(tree_input_1.TreeInput, { popupOpen: popupOpen, setPopupOpen: setPopupOpen, textValue: textValue, setTextValue: setTextValue, setSearchQuery: setSearchQuery, anchorElRef: anchorElRef, inputRef: inputRef }),
            !!value && value.length > 0 && react_1.default.createElement(tree_chips_1.TreeChips, { values: sorted })))),
        popupOpen && anchorElRef && (react_1.default.createElement(tree_popup_1.TreePopup, { setPopupOpen: setPopupOpen, setTextValue: setTextValue, anchorElRef: anchorElRef }))));
}
exports.Tree = Tree;
//# sourceMappingURL=tree.js.map